import React, { useEffect } from 'react';
import { useState } from 'react';
import { Table } from 'react-bootstrap';
import MakeAdminRow from './MakeAdminRow';

const MakeAdmin = () => {
    const [allUser, setAllUser] = useState([]);
    useEffect(() => {
        fetch('https://warehouse-management-server-30mo.onrender.com/users')
            .then(res => res.json())
            .then(data => setAllUser(data))
    }, [])

    return (
        <div style={{ backgroundColor: '#021B29', width: "83%" }} >
            <h3 className='text-white my-3'>Make An Admin Here</h3>
            <Table style={{ backgroundColor: '#021B29', color: 'white' }} bordered responsive="sm" >
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>User Email</th>
                        <th>Admin/General</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allUser.map((user, index) => <MakeAdminRow
                            key={user._id}
                            user={user}
                            index={index}
                        >
                        </MakeAdminRow>)
                    }
                </tbody>
            </Table>
        </div>
    );
};

export default MakeAdmin;